const clientActivityDt              = require('./clientActivity-dt')
const clientActivityMenu            = require('./clientActivity-menu')
const clientActivityPage            = require('./clientActivity-page')
const clientActivitySnack           = require('./clientActivity-snack')
const clientActivityReport          = require('./clientActivity-report')

export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      dt:              { start: (detail)=>{  clientActivityDt. start(detail)              }},
      menu:            { start: (detail)=>{  clientActivityMenu.start(detail)             }},
      page:            { start: (detail)=>{  clientActivityPage.start(detail)             }},
      snack:           { start: (detail)=>{  clientActivitySnack.start(detail)            }},
      report:          { start: (detail)=>{  clientActivityReport.start(detail)           }},

}